import {
  FETCH_REPORT_REQUEST,
  FETCH_REPORT_SUCCESS,
  FETCH_REPORT_ERROR,
} from 'actionTypes'

const DEFAULT_STATE = {
  get: {
    record: {},
    error: null,
    isFetching: false,
  },
}

const record = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case FETCH_REPORT_REQUEST:
      return {
        ...state,
        get: {
          ...state.get,
          isFetching: true,
        },
      }

    case FETCH_REPORT_SUCCESS:
      return {
        ...state,
        get: {
          ...state.get,
          isFetching: false,
          error: null,
          record: action.payload,
        },
      }

    case FETCH_REPORT_ERROR:
      return {
        ...state,
        get: {
          ...state.get,
          isFetching: false,
          record: {},
          error: action.payload,
        },
      }

    default:
      return state
  }
}

export default record
